<style scoped>
.nav-link {
  font-size: 1.2rem;
  color: black;
}
</style>
<template>
  <div class="topBar textSt p-3">
    <ul class="nav justify-content-end">
      <li class="nav-item dropdown textSt">
        <a class="nav-link dropdown-toggle textSt" data-bs-toggle="dropdown" href="#" role="button"
          aria-expanded="false">
          <i v-if="theme == 'dark-mode'" class="bi bi-moon-stars-fill pe-2 textSt"></i>
          <i v-if="theme == 'light-mode'" class="bi bi-brightness-high-fill pe-2 textSt"></i>
          <i v-if="theme == themeClient" class="bi bi-award-fill pe-2 textSt"></i>
        </a>
        <ul class="dropdown-menu textLt">
          <li @click="toggleTheme('dark-mode')"><a class="dropdown-item textSt" href="#"> <i
                class="bi bi-moon-stars-fill pe-2 textSt"></i> Modo nocturno</a></li>
          <li @click="toggleTheme('light-mode')"><a class="dropdown-item textSt" href="#"> <i
                class="bi bi-brightness-high-fill pe-2 textSt"></i> Modo dia</a></li>
          <li @click="toggleTheme(themeClient)"><a class="dropdown-item textSt" href="#"> <i
                class="bi bi-award-fill pe-2 textSt"></i> Modo personalizado</a></li>
        </ul>
      </li>
      <li class="nav-item">
        <div class="nav-link" @click="toggleNotifications">
          <i class="bi bi-bell textSt"></i>
          <!-- Circulo rojo con el número de notificaciones -->
          <span v-if="alerts.length > 0" class="notification-badge">
            {{ alerts.length }}
          </span>
        </div>
        <!-- Usa Bootstrap 5; backdrop = static, sin botón X -->
        <!-- Backdrop negro -->
        <div v-if="showUsdModal" class="modal-backdrop fade show">
        </div>
        <!-- backdrop = static     keyboard = false  -->
        <div class="modal fade" :class="{ show: showUsdModal }" style="display:block" v-if="showUsdModal"
          data-bs-backdrop="static" data-bs-keyboard="false">

          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

              <div class="modal-header">
                <h5 class="modal-title text-black">Actualización de divisa requerida</h5>
              </div>

              <form @submit.prevent="saveNewUsd">
                <div class="modal-body">
                  <p v-if="usdForm.editingCurrent">
                    No se ha definido aún el valor del dólar correspondiente a este mes
                    (<strong>{{ usdForm.nextLabel }}</strong>).
                    Por favor ingrésalo a continuación.
                  </p>

                  <p v-else class="small text-muted">
                    Quedan menos de dos&nbsp;días para que termine el mes y el valor
                    del dólar aún corresponde a este mes.
                    Introduce el tipo de cambio para el próximo mes
                    (<strong>{{ usdForm.nextLabel }}</strong>).
                  </p>

                  <p v-if="!usdForm.editingCurrent">
                    Valor actual de este mes:
                    <strong v-if="usdForm.currentValue">$
                      {{ usdForm.currentValue }}
                    </strong>
                    <span v-else>No definido</span>
                  </p>

                  <div class="input-group">
                    <span class="input-group-text">USD</span>

                    <!-- valor numérico -->
                    <input type="number" class="form-control" min="0" step="0.0001" required v-model="usdForm.value"
                      :disabled="usdForm.sending">

                    <!-- fecha sólo lectura -->
                    <span class="input-group-text bg-light">
                      {{ usdForm.nextLabel }}
                    </span>
                  </div>

                </div>

                <div class="modal-footer d-block">
                  <button type="submit" class="btn btn-success w-100 mb-2"
                    :disabled="usdForm.sending || !usdForm.value">
                    {{ usdForm.sending ? 'Guardando…' : 'Guardar nuevo valor' }}
                  </button>

                  <button type="button" class="btn btn-outline-danger w-100" @click="forceLogout"
                    :disabled="usdForm.sending">
                    Cerrar sesión
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
        <!-- Desplegable de alertas -->
        <div v-if="showNotifications" class="notifications-dropdown">
          <div class="cont">
            <h5>Notificaciones</h5>
            <ul v-if="alerts.length > 0">
              <li v-for="alert in alerts" :key="alert.id" :class="{ 'unread': !alert.is_read }"
                @click="handleAlertClick(alert)">
                <a style="text-decoration: none; color: inherit;">
                  <strong style="font-size: 0.9rem;">{{ alert.title }}</strong>
                  <small style="font-size: 0.8rem;">{{ alert.message }}</small>
                  <br>
                  <small>{{ alert.created_at }}</small>
                </a>
              </li>
            </ul>
            <ul v-else>
              <p>Sin notificaciones pendientes</p>
            </ul>
          </div>
          <div class="text-center">
            <a href="/alerts">Ver todas las notificaciones</a>
          </div>

        </div>
      </li>
      <li class="nav-item">
        <div class="nav-link d-none">
          <i class="bi bi-chat textSt"></i>
        </div>
      </li>
      <li class="nav-item dropdown textSt">
        <div class="nav-link dropdown-toggle textSt" data-bs-toggle="dropdown" href="#" role="button"
          aria-expanded="false">
          <i class="bi bi-person-circle pe-2 textSt"></i>
          <span>{{ user.name }}</span>
        </div>

        <ul class="dropdown-menu textLt">

          <!--li><a class="dropdown-item textSt" href="#">Reportar Error</a></li>
          <li><a class="dropdown-item textSt" href="#">Configuracion</a></li>
          <li>
            <hr class="dropdown-divider" />
          </li-->
          <li><a class="dropdown-item textSt" @click="logOut()">Cerrar Session</a></li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { penultimoDiaHabil } from '@/helpers/fechas'
export default {
  components: {
  },
  data() {
    return {
      showUsdModal: false,
      usdForm: {
        nextLabel: '',   // Ej: «Junio-2025»
        nextDate: '',    // Ej: «2025-06-01»
        value: '',
        sending: false,
        currentValue: null,
        editingCurrent: false    // ← nuevo flag
      },
      theme: localStorage.getItem('theme') || 'light-mode',
      themeClient: '',
      currentUrl: '',
      alerts: [],
      showNotifications: false,
      user: {
        name: '',
        id_client: ''
      }
    }
  },
  computed: {

  },
  async mounted() {
    document.body.className = this.theme;
    this.currentUrl = window.location.pathname;

    let sessionData = localStorage.getItem('user');
    this.user = JSON.parse(sessionData);


    await this.checkDollarUpdate();
    this.themeClient = this.user.company.skin;

    window.Echo.connector.pusher.connection.bind('connected', () => {
      console.log("Conexión exitosa con Pusher");
    });

    window.Echo.channel(`user.${this.user.id_user}`)
      .listen('.new-alert', (e) => {
        this.alerts.push(e.alert);

      });
    this.getAlerts(this.user.id_user)
    //this.isLogin();
  },
  methods: {
    async handleAlertClick(alert) {
      try {
        // Actualiza el estado en el servidor
        await axios.get(`/api/alerts/${alert.id_alert}/mark-as-read`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        })
        // Actualiza localmente
        alert.is_read = 1;

        // Redirige a la URL
        window.location.href = alert.url;
      } catch (error) {
        console.error("Error al marcar la alerta como leída:", error);
      }
    },
    async checkDollarUpdate() {
      if (this.user.change_currency !== 1) return;

      const today = dayjs();
      const currYear = today.year();
      const currMonth = today.month() + 1;

      const nextMonthD = today.add(1, 'month').startOf('month');
      const nextYear = nextMonthD.year();
      const nextMonth = nextMonthD.month() + 1;

      // 1) Verificar si existe valor para el mes actual
      let currentMonthExists = false;
      try {
        await axios.post('/api/dollar-get-rate', { year: currYear, month: currMonth }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        currentMonthExists = true;
      } catch (e) {
        currentMonthExists = false;
      }

      // 2) Si NO existe el valor del mes actual → solicitar inmediatamente
      if (!currentMonthExists) {
        this.prepareModal(currYear, currMonth, today, true);
        return;
      }

      // 3) Si existe, ver si estamos en penúltimo o último día hábil
      const penultHab = penultimoDiaHabil(currYear, currMonth);
      const ultHab = penultHab.add(1, 'day'); // asumimos penúltimo + 1

      const isPenultOrLast = today.isSame(penultHab, 'day') || today.isSame(ultHab, 'day');
      if (!isPenultOrLast) return;

      // 4) Verificar si ya existe valor del mes siguiente
      let nextMonthExists = false;
      try {
        await axios.post('/api/dollar-get-rate', { year: nextYear, month: nextMonth }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        nextMonthExists = true;
      } catch (e) {
        nextMonthExists = false;
      }

      // 5) Si no existe → pedir
      if (!nextMonthExists) {
        this.prepareModal(nextYear, nextMonth, nextMonthD, false);
      }
    },
    prepareModal(year, month, referenceDate, editingCurrent = false) {
      this.usdForm.nextLabel = referenceDate.format('MMMM-YYYY');
      this.usdForm.nextDate = referenceDate.format('YYYY-MM-DD');
      this.usdForm.editingCurrent = editingCurrent;
      this.usdForm.value = '';
      this.usdForm.currentValue = null;

      if (!editingCurrent) {
        // solo si estamos pidiendo el mes siguiente, mostramos el valor del actual
        const today = dayjs();
        const currYear = today.year();
        const currMonth = today.month() + 1;

        axios.post('/api/dollar-get-rate', { year: currYear, month: currMonth }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        }).then(({ data }) => {
          this.usdForm.currentValue = data.dollar_value;
        }).catch(() => { });
      }

      this.showUsdModal = true;
    },
    async saveNewUsd() {
      if (!this.usdForm.value) return        // vacío → nada que hacer
      this.usdForm.sending = true

      /* ➊ desglosamos año / mes */
      const d = dayjs(this.usdForm.nextDate)   // ej. 2025-06-01
      const payload = {
        year: d.year(),         // 2025
        month: d.month() + 1,    // 0-based → +1 ⇒ 6
        dollar_value: this.usdForm.value
      }

      try {
        await axios.post('/api/exchangeDollar', payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        })

        /* ➋ marcamos que ya se actualizó este mes */
        const flag = `usdModal_${dayjs().format('YYYY_MM')}`
        localStorage.setItem(flag, '1')

        /* ➌ UI */
        this.showUsdModal = false
        this.usdForm.value = ''
        this.usdForm.sending = false

        this.$swal.fire({
          icon: 'success',
          title: 'Tipo de cambio actualizado',
          timer: 2000,
          showConfirmButton: false
        })
      } catch (err) {
        this.usdForm.sending = false

        /* cuando el backend responde 400 si ya existe la tasa */
        const msg = err.response?.data?.message || 'No se pudo guardar el cambio'
        this.$swal.fire({
          icon: 'error',
          title: msg,
          text: 'Intenta nuevamente o contacta a soporte'
        })
      }
    },
    /** cierra sesión (única opción del modal) */
    async forceLogout() {
      try {
        await axios.post('/api/auth/logout', {}, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
      } catch (e) {/* ignoramos */ }
      localStorage.clear();
      window.location.href = '/login';
    },
    showNotification(alert) {
      // Mostrar la notificación en pantalla
      console.log("Nueva alerta:", alert);
      // Aquí puedes usar librerías como Toastr o implementaciones propias
    },
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
    },
    async getAlerts(id) {
      const self = this;
      try {

        const response = await axios.get('/api/user/' + id + '/alertsunread', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        });

        self.alerts = response.data;
      } catch (error) {
        console.error('Error alert get:', error);
      }

    },
    logOut() {
      localStorage.removeItem('accessToken');
      window.location.href = './../../api/auth/logout'
    },
    toggleTheme(theme) {
      this.theme = theme;
      document.body.className = this.theme;
      localStorage.setItem('theme', this.theme);
    },
  },
};
</script>